import { apiRequest } from "@/lib/api";
import type {
  ShippingQuotePayload,
  ShippingQuoteResponse,
} from "@/types/shipping";


export function quoteShipping(
  slug: string,
  payload: ShippingQuotePayload,
) {
  return apiRequest<ShippingQuoteResponse>(
    `/shipping/public/${slug}/quote/`,
    {
      method: "POST",
      body: JSON.stringify(payload),
    },
  );
}
